import { connect } from 'react-redux';
import Report from '../../components/digital_rating/Report';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
